export const isEmptyObject = (object: {}) => {
    for (const item in object) {
        if (object.hasOwnProperty(item)) return false
    }
    return true
}
